import React from "react";
import { Grid, Box, Typography, Button, Link, Hidden, IconButton } from "@material-ui/core";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import { Link as RouterLink } from "react-router-dom";
import { Avatar } from "./Avatar";
import { Container } from "./Container";

interface Props {
  title: string;
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl" | false;
  loggedUserName?: string;
  login: () => void;
  logout: () => void;
}

const LoginButton = ({ login }: { login: () => void }) => (
  <>
    <Hidden only="xs">
      <Button variant="contained" color="secondary" onClick={login}>
        Kirjaudu sisään
      </Button>
    </Hidden>
    <Hidden smUp>
      <IconButton color="secondary" onClick={login}>
        <PowerSettingsNewIcon fontSize="small" />
      </IconButton>
    </Hidden>
  </>
);

const LogoutButton = ({ logout }: { logout: () => void }) => (
  <>
    <Hidden only="xs">
      <Button variant="contained" color="secondary" onClick={logout}>
        Kirjaudu ulos
      </Button>
    </Hidden>
    <Hidden smUp>
      <IconButton color="secondary" onClick={logout}>
        <PowerSettingsNewIcon fontSize="small" />
      </IconButton>
    </Hidden>
  </>
);

const AlkoHeader = ({ maxWidth, title, loggedUserName, login, logout }: Props): JSX.Element => {
  return (
    <Container maxWidth={maxWidth} bgColor="primary.main">
      <Box px={{ xs: 2, md: 4 }} py={1}>
        <Grid container direction="row" alignItems="center" wrap="nowrap">
          <Grid item>
            <Box flex="1">
              <Box
                width={{ xs: 30, sm: 60, md: 80 }}
                height={{ xs: 30, sm: 60, md: 80 }}
                className="icon-alko-logo-red"
              />
            </Box>
          </Grid>
          <Grid item>
            <Box px={{ xs: 1, md: 4 }}>
              <Typography variant="h1" style={{ color: "white" }}>
                <Link component={RouterLink} to="/" style={{ color: "white" }} underline="none">
                  {title}
                </Link>
              </Typography>
            </Box>
          </Grid>
          <Grid container item xs justify="flex-end" alignItems="flex-end" direction="column">
            <Grid item>
              {loggedUserName ? (
                <Avatar name={loggedUserName} popup={<LogoutButton logout={logout} />} />
              ) : (
                <LoginButton login={login} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default AlkoHeader;
